/**
 * Created by sagardesai on 11/07/18.
 */

import {RSAA} from 'redux-api-middleware';
import {API_ENDPOINT, AUTH_HEADERS} from "../../util/constants";
import * as types from "../types";
import {handleUnauthorizedAccess} from "../../util/utility";

export function sendMessage(token, api_token, data ) {

    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/send/message?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.SEND_MESSAGE_REQUEST, types.SEND_MESSAGE_RECEIVE, {
                type: types.SEND_MESSAGE_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetSendMessage = () => ({
    type: types.RESET_SEND_MESSAGE,
    payload: null
});

export const hideMessageModal = (data) => ({
    type: types.HIDE_MESSAGE_MODAL,
    payload: data
});

export const showMessageModal = (data) => ({
    type: types.SHOW_MESSAGE_MODAL,
    payload: data
});

